export const darkStyles = {
    'code': {
        'font_color': '#e3eaef',
        'border_color': '#47515d',
        'border_style': 'solid',
        'input_border_radius': '0.25rem',
        'font_size': '0.875rem',
        'input_border_width': '1px',
        'input_font': 'inherit',
        'input_font_weight': '400',
        'input_margin': '5px 0px 5px 20px',
        'input_padding': '0px 5px 0px 5px',
        'label_color': '#aab8c5',
        'label_size': '16px',
        'label_width': '150px',
        'label_font': 'sans-serif, arial, serif',
        'label_font_weight': 'normal',
        'label_margin': '5px 0px 0px 20px',
        'label_padding': '2px 5px 2px 5px',
        'label_border_style': 'none',
        'label_border_color': 'none',
        'label_border_radius': '0.25rem',
        'label_border_width': '2px',
        'background_color': 'transparent',
        'height': '25px',
        'width': '110px',
        'padding_bottom': '2px'
    },
    'cc': {
        'font_color': '#e3eaef',
        'border_color': '#47515d',
        'border_style': 'solid',
        'font_size': '0.875rem',
        'input_border_radius': '0.25rem',
        'input_border_width': '1px',
        'input_font': 'inherit',
        'input_font_weight': '400',
        'input_margin': '5px 0px 5px 0px',
        'input_padding': '0px 5px 0px 5px',
        'label_color': '#aab8c5',
        'label_size': '16px',
        'label_width': '150px',
        'label_font': 'Times New Roman, sans-serif, serif',
        'label_font_weight': 'normal',
        'label_margin': '5px 0px 0px 0px',
        'label_padding': '0px 5px 0px 5px',
        'label_border_style': 'none',
        'label_border_color': 'none',
        'label_border_radius': '0.25rem',
        'label_border_width': '0px',
        'background_color': 'transparent',
        'height': '25px',
        'width': '320px',
        'padding_bottom': '0px'
    },
    'exp': {
        'font_color': '#e3eaef',
        'border_color': '#47515d',
        'border_style': 'solid',
        'font_size': '0.875rem',
        'input_border_radius': '0.25rem',
        'input_border_width': '1px',
        'input_font': 'inherit',
        'input_font_weight': '400',
        'input_margin': '5px 0px 5px 0px',
        'input_padding': '0px 5px 0px 5px',
        'label_color': '#aab8c5',
        'label_size': '16px',
        'label_width': '150px',
        'label_font': 'inherit',
        'label_font_weight': 'normal',
        'label_margin': '5px 0px 0px 0px',
        'label_padding': '2px 5px 2px 5px',
        'label_border_style': 'dashed',
        'label_border_color': 'none',
        'label_border_radius': '0rem',
        'label_border_width': '0px',
        'background_color': '#343a40',
        'height': '25px',
        'width': '85px',
        'padding_bottom': '2px',
        'type': 'dropdown'
    },
    'body': {
        'background_color': 'transparent',
        'padding_top': '100px'
    }
};

export const lightStyles = {
    'code': {
        'font_color': '#323a46',
        'border_color': '#e6e6e6',
        'border_style': 'solid',
        'input_border_radius': '0.25rem',
        'font_size': '0.875rem',
        'input_border_width': '1px',
        'input_font': 'inherit',
        'input_font_weight': '400',
        'input_margin': '5px 0px 5px 20px',
        'input_padding': '0px 5px 0px 5px',
        'label_color': '#323a46',
        'label_size': '16px',
        'label_width': '150px',
        'label_font': 'sans-serif, arial, serif',
        'label_font_weight': 'normal',
        'label_margin': '5px 0px 0px 20px',
        'label_padding': '2px 5px 2px 5px',
        'label_border_style': 'none',
        'label_border_color': 'none',
        'label_border_radius': '0.25rem',
        'label_border_width': '2px',
        'background_color': 'transparent',
        'height': '25px',
        'width': '110px',
        'padding_bottom': '2px'
    },
    'cc': {
        'font_color': '#323a46',
        'border_color': '#e6e6e6',
        'border_style': 'solid',
        'font_size': '0.875rem',
        'input_border_radius': '0.25rem',
        'input_border_width': '1px',
        'input_font': 'inherit',
        'input_font_weight': '400',
        'input_margin': '5px 0px 5px 0px',
        'input_padding': '0px 5px 0px 5px',
        'label_color': '#323a46',
        'label_size': '16px',
        'label_width': '150px',
        'label_font': 'Times New Roman, sans-serif, serif',
        'label_font_weight': 'normal',
        'label_margin': '5px 0px 0px 0px',
        'label_padding': '0px 5px 0px 5px',
        'label_border_style': 'none',
        'label_border_color': 'none',
        'label_border_radius': '0.25rem',
        'label_border_width': '0px',
        'background_color': 'transparent',
        'height': '25px',
        'width': '320px',
        'padding_bottom': '0px'
    },
    'exp': {
        'font_color': '#323a46',
        'border_color': '#e6e6e6',
        'border_style': 'solid',
        'font_size': '0.875rem',
        'input_border_radius': '0.25rem',
        'input_border_width': '1px',
        'input_font': 'inherit',
        'input_font_weight': '400',
        'input_margin': '5px 0px 5px 0px',
        'input_padding': '0px 5px 0px 5px',
        'label_color': '#323a46',
        'label_size': '16px',
        'label_width': '150px',
        'label_font': 'inherit',
        'label_font_weight': 'normal',
        'label_margin': '5px 0px 0px 0px',
        'label_padding': '2px 5px 2px 5px',
        'label_border_style': 'dashed',
        'label_border_color': 'none',
        'label_border_radius': '0rem',
        'label_border_width': '0px',
        'background_color': '#fff',
        'height': '25px',
        'width': '85px',
        'padding_bottom': '2px',
        'type': 'dropdown'
    },
    'body': {
        'background_color': 'transparent',
        'padding_top': '100px'
    }
};

